// src/v2/components/modules/Reports/EmployeeContributionHistory/EmployeeContributionHistoryModule.js
import React, { useState, useCallback } from 'react';
import { LoadingSpinner } from '../../../../../common/Loading';
import { Button } from '../../../../../common/APICommon';
import { EmployeePickerField } from "../../../../../common/selectComponents/EmployeePicker";

export const EmployeeContributionHistoryModule = ({ reportHook }) => {
  const [errorState, setErrorState] = useState(false);

  // Local States
  const [selectedEmployeePersonalInformationId, setSelectedEmployeePersonalInformationId] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleClear = useCallback(() => {
    setSelectedEmployeePersonalInformationId("");
    setSelectedEmployee(null);
    setDateFrom("");
    setDateTo("");
    setErrorState(false);
  }, []);

  const handleGenerate = () => {
    if (!selectedEmployeePersonalInformationId) {
      setErrorState(true);
      alert("Please select an employee first.");
      return;
    }

    const queryParams = {
      employeeId: selectedEmployeePersonalInformationId,
      dateFrom,
      dateTo
    };

    setErrorState(false);

    // Trigger Direct Download logic
    reportHook.generateAndDownload(queryParams, selectedEmployee?.fullName, dateFrom, dateTo);
  };

  return (
    <div className="ReportsInfo shadow-xl bg-white rounded-lg p-6 border border-gray-100">

      {/* Breadcrumb Style - PRESERVED EXACTLY */}
      <div className='flex items-center text-sm mb-2'>
        <span className="text-gray-400">Reports</span>
        <span className="mx-2 text-gray-400">{">"}</span>
        <span className="border-b border-gray-800 text-gray-800 font-medium tracking-tight">Employee Contribution History (Philhealth)</span>
      </div>

      {/* H3 Section - PRESERVED EXACTLY */}
      <div className="mb-6">
        <h3 className="text-xl font-bold text-customMainColor uppercase tracking-tight">Employee Contribution History (Philhealth)</h3>
      </div>

      {/* Filter Section */}
      <div className="bg-gray-50 p-5 rounded-xl border border-gray-200 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">

          {/* Employee Picker */}
          <div className="w-full flex flex-col justify-center">
            <EmployeePickerField
              label="Employee:"
              employeePersonalInformationId={selectedEmployeePersonalInformationId}
              displayValue={selectedEmployee ? `${selectedEmployee.fullName}` : ""}
              onSelect={(emp) => {
                if (emp) {
                  setSelectedEmployee(emp);
                  setSelectedEmployeePersonalInformationId(emp.id);
                }
              }}
              error={!selectedEmployeePersonalInformationId && errorState}
              errorMessage="Please select an employee"
              allowClear={true}
              onClear={() => {
                setSelectedEmployee(null);
                setSelectedEmployeePersonalInformationId("");
              }}
            />
          </div>

          {/* Date Range Selection */}
          <div className="flex flex-col justify-center my-2">
            <label className="text-sm font-medium text-gray-700 mb-1">Date From</label>
            <input
              type="date"
              className={`h-[34px] border rounded px-2 text-sm border-gray-300 outline-none focus:border-blue-500 transition-colors
                        ${dateFrom ? "text-gray-700 font-semibold" : "text-gray-400"}`}
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </div>
          <div className="flex flex-col justify-center my-2">
            <label className="text-sm font-medium text-gray-700 mb-1">Date To</label>
            <input
              type="date"
              className={`h-[34px] border rounded px-2 text-sm border-gray-300 outline-none focus:border-blue-500 transition-colors
                        ${dateTo ? "text-gray-700 font-semibold" : "text-gray-400"}`}
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </div>

        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mt-8 border-t border-gray-200 pt-5">
          <Button
            name="GENERATE & DOWNLOAD"
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2.5 rounded-lg font-bold shadow-sm transition-all"
            onClick={handleGenerate}
          />
          <Button
            name="CLEAR"
            className="bg-white border border-gray-300 text-gray-600 hover:bg-gray-100 px-8 py-2.5 rounded-lg font-bold transition-all"
            onClick={handleClear}
          />
        </div>
      </div>

      <LoadingSpinner loading={reportHook.loading} />
    </div>
  );
};